import {GamesState} from '../reducers/games.reducer';

export const getGamesState = (state): GamesState => {
    return state.get('games');
};
